import codes from "../../../errorCodes/legacy/Onboarding";
export default function tenantErrorHandler(code) {
    switch (code) {
        case codes.RequestUrlParamMissing:
            return "errors.PBONBRequestUrlParamMissing";
        case codes.RequestBodyInvalid:
            return "errors.PBONBRequestBodyInvalid";
        case codes.EmptyField:
            return "errors.PBONBEmptyField";
        case codes.OnboardingNotFound:
            return "errors.PBONBOnboardingNotFound";
        case codes.OnboardingAlreadyExists:
            return "errors.PBONBOnboardingAlreadyExists";
        case codes.FlowNotFound:
            return "errors.PBONBFlowNotFound";
        case codes.StepDoesNotBelong:
            return "errors.PBONBStepDoesNotBelong";
        case codes.UserDisabled:
            return "errors.PBONBUserDisabled";
        case codes.InitialOnboardingCompleted:
            return "errors.PBONBInitialOnboardingCompleted";
        case codes.ResendWelcomeEmailSamlUser:
            return "errors.PBONBResendWelcomeEmailSamlUser";
        case codes.BusinessOnboardingNotFound:
            return "errors.PBONBBusinessOnboardingNotFound";
        case codes.InvalidStepState:
            return "errors.PBONBInvalidState";
        case codes.InvalidStepSelection:
            return "errors.PBONBInvalidSelection";
        default:
            return "";
    }
}
